<template>
  <form class="modal-project-create-first" @submit.prevent="onSubmit">
    <div class="slot1">
      <span>{{
        selectedType === "mpm" || selectedType === "crash"
          ? $t("project.add.title")
          : $t("project.add.title_project")
      }}</span>
    </div>
    <div class="slot2">
      <img
        src="/../img/logo-mpm-pg.svg"
        :class="selected('mpm')"
        @click="selectType('mpm')"
      />
      <span class="vertical-line"></span>
      <img
        src="/../img/logo-crash-pg.svg"
        :class="selected('crash')"
        @click="selectType('crash')"
      />
      <span v-if="this.$store.state.is_superuser" class="vertical-line"></span>
      <img
        v-if="this.$store.state.is_superuser"
        src="/../img/logo-wpm-pg.svg"
        :class="selected('wpm')"
        @click="selectType('wpm')"
      />
    </div>
    <div class="slot3">
      <ccombobox
        :init_width="'100%'"
        :init_height="'43px'"
        :init_title="teamTitle"
        :init_items="teamList"
        @selectItem="teamClickEvent"
        :init_disable="$store.state.project.selectedTeamId"
      />
    </div>
    <div class="slot4">
      <input
        type="text"
        :placeholder="
          selectedType === 'mpm' || selectedType === 'crash'
            ? $t('project.add.project_name')
            : $t('project.add.project_name_web')
        "
        v-model="projectName"
        maxlength="100"
        required
      />
    </div>
    <div
      v-if="selectedType === 'mpm' || selectedType === 'crash'"
      class="slot5"
    >
      <input
        type="text"
        :placeholder="$t('project.add.package_name')"
        v-model="packageName"
        maxlength="100"
        required
      />
    </div>
    <div v-else class="slot5-wpm">
      <ccombobox
        :init_width="'22%'"
        :init_height="'43px'"
        :init_title="protocolTitle"
        :init_items="protocolList"
        @selectItem="protocolClickEvent"
      />
      <input
        type="text"
        class="input-url"
        :placeholder="$t('project.add.project_url')"
        v-model="packageName"
        maxlength="100"
        required
      />
    </div>
    <div class="slot6">
      <div
        v-if="selectedType === 'mpm' || selectedType === 'crash'"
        class="slot6-inner"
      >
        <div class="left">
          <div class="radio-box">
            <input
              type="radio"
              name="platform"
              v-model="projectPlatform"
              value="android"
              required
            />
            <span>{{ $t("platform.android") }}</span>
            <input
              type="radio"
              name="platform"
              v-model="projectPlatform"
              value="ios"
              required
            />
            <span>{{ $t("platform.ios") }}</span>
          </div>
        </div>
        <div class="right">
          <ccombobox
            :init_width="'156px'"
            :init_height="'43px'"
            :init_title="webviewTitle"
            :init_items="webviewList"
            @selectItem="webviewClickEvent"
          />
        </div>
      </div>
      <div v-else class="slot6-inner-wpm">
        <ul>
          <li class="color_blue">{{ $t("project.add.web.text1") }}</li>
          <li>{{ $t("project.add.web.text2") }}</li>
          <li>{{ $t("project.add.web.text3") }}</li>
        </ul>
      </div>
    </div>
    <span class="seperate-line"></span>
    <div class="slot7">
      <button class="submit-btn" type="submit">
        {{ $t("project.menu.submit") }}
      </button>
      <button class="cancel-btn" type="reset" @click="onCancel">
        {{ $t("common.cancel") }}
      </button>
    </div>
    <div class="pc-spinner-back" v-if="loading">
      <spinner :loading="loading" :init_color="'dark'" />
    </div>
  </form>
</template>

<script>
import axios from "axios";
import Ccombobox from "@/views/components/ccombobox.vue";
import Spinner from "@/views/components/blade-spinner.vue";

export default {
  name: "modal-project-create-first",
  components: {
    Spinner,
    Ccombobox,
  },
  data: function () {
    return {
      selectedType: "mpm",
      selectedTeam: this.$store.state.project.selectedTeamId,
      selectedWebview: "native",
      selectedProtocol: "https://",
      teamTitle: this.$store.state.project.selectedTeamName,
      webviewTitle: this.$t("project.add.native"),
      protocolTitle: "https://",
      teamList: [],
      webviewList: [],
      protocolList: [],
      projectPlatform: "android",
      projectName: "",
      packageName: "",
      loading: false,
      expUrl: /^(http|https):\/\/(([\w\-]+(\.[\w\-]+)+)|localhost)(:\d+)?/i,
    };
  },
  computed: {
    selected: function () {
      return (type) => {
        if (type === this.selectedType) {
          return "selected";
        } else {
          return "not-selected";
        }
      };
    },
  },
  created: function () {
    this.teamList = [{ key: 0, label: "(default)" }];
    for (const i of this.$store.state.project.teamList) {
      this.teamList.push({
        key: i.id,
        label: i.name,
      });
    }
    this.webviewList = [
      { key: "native", label: this.$t("project.add.native") },
      { key: "webview", label: this.$t("project.add.webview") },
    ];
    this.protocolList = [
      { key: "https://", label: "https://" },
      { key: "http://", label: "http://" },
    ];
  },
  methods: {
    onClick: function () {
      this.$emit("closeEvent", true);
    },
    preventClick: function (event) {
      event.stopPropagation();
      event.preventDefault();
    },
    onSubmit: function () {
      // add click prevent
      document.addEventListener("click", this.preventClick, true);

      // WEB 프로젝트일 경우 URL 형식이 체크
      if (
        this.selectedType === "wpm" &&
        !this.checkUrl(this.selectedProtocol + this.packageName)
      ) {
        alert(this.$t("project.add.url_fail"));
        document.removeEventListener("click", this.preventClick, true);
        return;
      }

      this.loading = true;

      const query = {
        project_name: this.projectName,
        package_name:
          this.selectedType === "wpm"
            ? this.selectedProtocol + this.packageName
            : this.packageName,
        stage: 1,
        platform: this.selectedType === "wpm" ? "web" : this.projectPlatform,
        service: this.selectedType,
        team_id: this.selectedTeam,
        team_name: this.teamTitle,
        is_superuser: this.$store.state.is_superuser,
        screen_type: this.selectedType === "wpm" ? "web" : this.selectedWebview,
      };

      axios
        .post("/api/project", query)
        .then((result) => {
          if (result.data.project_key) {
            return result.data;
          }
        })
        .then((info) => {
          this.$store.commit("project/setCreatedKeyValue", info.project_key);
          this.$store.commit("project/setCreatedPIdValue", info.project_id);
          this.$store.commit(
            "setModalProps",
            Object.assign(this.$store.state.modalProps, {
              pKey: info.project_key,
            })
          );
        })
        .then(() => {
          setTimeout(() => {
            axios
              .post(
                `/api/agents/projects/${this.$store.state.project.createdPIdValue}/setting`,
                this.$store.state.project.sdkOption
              )
              .then(() => {
                // if(res.data.msg == "success!!"){}
              })
              .then(() => {
                axios.post("/api/agents/setting/refresh").then(() => {
                  // alert(this.$t('sdk.onoff_saved'))
                });
              });
          });
        })
        .then(() => {
          // remove click prevent
          document.removeEventListener("click", this.preventClick, true);
          this.$store.dispatch("project/getProjectList");
          this.loading = false;
          if (this.selectedType === "wpm")
            this.$store.commit("setModalType", "project-complete");
          else this.$emit("nextPage", true);
        })
        .catch(() => {
          // remove click prevent
          document.removeEventListener("click", this.preventClick, true);
          this.loading = false;
          alert(this.$t("project.add.fail"));
        });
    },
    onCancel: function () {
      this.onClick();
    },
    selectType: function (type) {
      this.selectedType = type;
    },
    teamClickEvent: function (value) {
      this.selectedTeam = value.key;
      this.teamTitle = value.label;
    },
    webviewClickEvent: function (value) {
      this.selectedWebview = value.key;
      this.webviewTitle = value.label;
    },
    protocolClickEvent: function (value) {
      this.selectedProtocol = value.key;
      this.protocolTitle = value.label;
    },
    checkUrl: function (strUrl) {
      return this.expUrl.test(strUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-project-create-first {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% - 59px);
  padding: 32px 40px 0px 40px;
  position: relative;
}
.slot1 {
  width: 100%;
  // margin-bottom: 30px;
  span {
    display: inline-block;
    width: 100%;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #000000;
  }
}
.slot2 {
  margin-top: 39px;
  margin-bottom: 25px;
  width: 100%;
  display: flex;
  img {
    display: block;
    width: 100px;
    height: 32px;
    margin: auto;
    cursor: pointer;
  }
  .vertical-line {
    border: 0.5px solid #e2e2e2;
    position: relative;
  }
}
.slot3 {
  width: 100%;
  margin-bottom: 10px;
}
@mixin input-text {
  width: 100%;
  height: 43px;
  border-radius: 10px;
  border: solid 1px #e0e0e0;
  background-color: #ffffff;
  padding: 13px 19px 14px 19px;
  display: block;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
}
.slot4 {
  width: 100%;
  input {
    @include input-text;
  }
  margin-bottom: 10px;
}
.slot5 {
  width: 100%;
  input {
    @include input-text;
  }
  margin-bottom: 10px;
}
.slot5-wpm {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  .input-url {
    @include input-text;
    margin-left: 10px;
    width: 78%;
  }
}
.slot6 {
  width: 100%;
  height: 57px;
  margin-bottom: 23px;
  .slot6-inner {
    width: 100%;
    margin-top: 14px;
    display: flex;
  }
  .slot6-inner-wpm {
    ul {
      padding-left: 20px;
      margin-top: 0px;
      li {
        font-size: 12px;
        color: #848484;
      }
    }
  }
  .left {
    display: flex;
    flex-direction: column;
  }
  .right {
    margin-left: auto;
    display: flex;
    flex-direction: column;
  }
}
.radio-box {
  display: flex;
  padding: 12px 0;
  input,
  span {
    display: flex;
    flex-direction: column;
  }
  span {
    font-size: 14px;
    font-weight: normal;
    margin-left: 5px;
    margin-right: 15px;
  }
}
.slot7 {
  width: 100%;
}
.seperate-line {
  width: 100%;
  height: 1px;
  border: solid 0.5px #e2e2e2;
  margin-bottom: 25px;
  box-sizing: border-box;
}
@mixin btn-text {
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  outline: none;
  border: none;
}
.submit-btn {
  @include btn-text;
  float: left;
  width: 192px;
  height: 43px;
  border-radius: 20px;
  box-shadow: 0 2px 4px 0 #c6d5e9;
  background-color: #4639de;
  border: none;
}
.cancel-btn {
  @include btn-text;
  float: right;
  margin-right: auto;
  width: 192px;
  height: 43px;
  border-radius: 20px;
  box-shadow: 0 2px 4px 0 #c6d5e9;
  background-color: #1c1f28;
  border: none;
}
.selected {
  transition: 0.2s;
  opacity: 1;
}
.not-selected {
  opacity: 0.2;
  transition: 0.2s;
  &:hover {
    transition: 0.2s;
    opacity: 0.7;
  }
}
.pc-spinner-back {
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  position: absolute;
  height: calc(59px + 100%);
  background-color: rgba(255, 255, 255, 0.5);
}
.color_blue {
  color: #4639de !important;
}
</style>
